<template>
  <v-row>
    <v-col cols="12">
      <h2 class="mt-4">Unit Attribute Designer</h2>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      lg="4"
    >
      <v-select
        data-testid="unit-attribute-types-select"
        class="unit-attribute-types-select"
        filled
        label="Unit Type in Property Management"
        :items="unitTypes"
        v-model="currentFacilityAttribute"
        ref="selectUnitType"
        clearable
      />
    </v-col>
    <unit-attribute-form
      :currentAttributeMap="currentAttributeMap"
      :productTypes="productTypes"
      :currentFacilityAttribute="currentFacilityAttribute"
      v-if="currentFacilityAttribute"
    />
  </v-row>
</template>

<script>
import UnitAttributeForm from "@/views/facility/partials/UnitAttributeForm.vue";

export default {
  data() {
    return {
      productTypes: [
        "Storage",
        "Parking"
      ],
      defaultTypeId: 99999999,
      currentAttributeMap: null,
      defaultObj: {
        name: null,
        productType: null,
        enabled: true,
        floor: {
          enabled: null,
          zero_value: null,
          one_value: null,
          two_plus_value: null
        },
        alarm: {
          enabled: null,
          on_value: null,
          off_value: null
        },
        climate: {
          enabled: null,
          on_value: null,
          off_value: null
        },
        mobile: {
          enabled: null,
          on_value: null,
          off_value: null
        },
        power: {
          enabled: null,
          on_value: null,
          off_value: null
        },
        inside: {
          enabled: null,
          on_value: null,
          off_value: null
        }
      }
    };
  },
  // @todo holy shit this spaghetti code thing needs a refactor
  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    },

    currentFacilityAttribute: {
      get() {
        return this.$store.state.facility.currentFacilityAttribute;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityAttribute", newValue);
        this.currentAttributeMap = this.currentFacility.unit_attribute_map[newValue];
      }
    },

    unitTypes() {
      const unitTypes = [{
        text: "Default",
        value: this.defaultTypeId
      }];

      if (this.currentFacility.price_list && this.currentFacility.price_list.price_list) {
        const priceList = this.currentFacility.price_list.price_list;

        priceList.map((item) => {
          if (unitTypes.indexOf(item.type_name) < 0) {
            unitTypes.push({
              text: item.type_name,
              value: item.type_id
            });
          }
        });
      }

      return unitTypes;
    }
  },

  components: {
    UnitAttributeForm
  },

  mounted() {
    this.$store.commit("setCurrentFacilityAttribute", null);

    if (!this.currentFacility.unit_attribute_map || !this.currentFacility.unit_attribute_map[this.defaultTypeId]) {
      this.$store.commit("setCurrentFacilityUnitAttributeMap", { [this.defaultTypeId]: JSON.parse(JSON.stringify(this.defaultObj)) });
    }

    if (this.currentFacility.price_list && this.currentFacility.price_list.price_list) {
      for (const key in this.currentFacility.price_list.price_list) {
        const item = this.currentFacility.price_list.price_list[key];

        if (!this.currentFacility.unit_attribute_map[item.type_id]) {
          this.$store.commit("setCurrentFacilityUnitAttributeMap", { [item.type_id]: JSON.parse(JSON.stringify(this.defaultObj)) });
        }
      }
    }
  }
};
</script>
